<template>
    <div class="setting-mode">
        <h1 class="mode-title">选择任务模式及预算</h1>

        <div class="form-mode">
            <div
                :class="['mode-item', { active: mode.id === formData.task_mode }]"
                v-for="mode in modeList"
                :key="mode.id"
                @click="handleChangeMode(mode.id)"
            >
                <div class="mode-info">
                    <div class="mode-label">{{ mode.label }}</div>

                    <div class="mode-desc">{{ mode.desc }}</div>

                    <div class="mode-process">{{ mode.process }}</div>
                </div>

                <img :src="mode.img" alt="" />
            </div>
        </div>

        <div class="form-list">
            <div class="form-item">
                <div class="form-item_label">需求预算</div>

                <div class="budget-input">
                    <el-input-number
                        class="budget-number"
                        v-model="formData.task_budget"
                        :min="1"
                        :max="999999999"
                        label="请输入预算金额"
                        :controls="false"
                        placeholder="请输入"
                    ></el-input-number>

                    <span>金币</span>
                </div>
            </div>

            <div class="form-item">
                <div class="form-item_label">{{ formData.task_mode === 1 ? "报名截止日期" : "交稿截止日期" }}</div>

                <el-date-picker
                    v-model="formData.task_start_time"
                    type="datetime"
                    value-format="yyyy-MM-dd HH:mm"
                    format="yyyy-MM-dd HH:mm"
                    placeholder="请选择"
                    style="width: 320px"
                    :picker-options="pickerOptions"
                >
                </el-date-picker>
            </div>

            <div class="form-item">
                <div class="form-item_label">期望完成日期</div>

                <el-date-picker
                    v-model="formData.task_end_time"
                    type="date"
                    value-format="yyyy-MM-dd 23:59:59"
                    placeholder="请选择"
                    style="width: 320px"
                    :picker-options="pickerOptions"
                >
                </el-date-picker>
            </div>
        </div>

        <div class="form-submit">
            <div class="submit-btn cancel" @click="handleCancel">取消</div>
            <div :class="['submit-btn', 'next', { disabled: !isNext }]" @click="handleNext">下一步，描述</div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            modeList: [
                {
                    id: 1,
                    label: "招募模式-先选人，再做事",
                    desc: "适合大型或周期较长的项目，如“开发一个网站”、“房屋装修设计”等",
                    process: "报名→需求方甄选→签订合同→接单方工作→验收交付成功→酬劳结算→评价",
                    img: require("@/assets/img/task-center/demand-widget-2.png"),
                },

                {
                    id: 2,
                    label: "竞单模式-作品说话，比创意",
                    desc: "适合创意类需求，如“取名”、“做个平面设计图”、“文案写作”等",
                    process: "交稿→需求方甄选→中标公示→验收交付成功→酬劳结算→评价",
                    img: require("@/assets/img/task-center/demand-widget-3.png"),
                },
            ],

            formData: {
                task_mode: 1,
                task_budget: undefined, // 预算
                task_end_time: null, // 期望时间
                task_start_time: null, // 截止时间
            },

            pickerOptions: {
                disabledDate: (time) => {
                    const today = new Date();
                    const endTime = new Date(`${today.getFullYear()}-${today.getMonth() + 1}-${today.getDate()} 00:00:00`);

                    return time.getTime() < endTime;
                },
            },
        };
    },

    computed: {
        isNext() {
            return this.formData.task_mode && this.formData.task_budget && this.formData.task_end_time && this.formData.task_start_time;
        },
    },

    methods: {
        handleChangeMode(id) {
            Object.assign(this.formData, {
                task_mode: id,
                task_budget: undefined,
                task_start_time: null,
                task_end_time: null,
            });
        },

        customValid() {
            const start_time = new Date(this.formData.task_start_time).getTime(); // 截止时间
            const end_time = new Date(this.formData.task_end_time).getTime(); // 期望时间

            if (start_time >= end_time) {
                this.$message.warning("期望时间需要要大于截止时间");
                return false;
            }

            if (start_time < Date.now()) {
                this.$message.warning("截止时间需要大于当前时间");
                return false;
            }

            return true;
        },

        handleNext() {
            if (!this.isNext) {
                this.$message.warning("请填写完整数据");
                return;
            }

            if (this.customValid()) {
                console.log(this.formData);
                this.$emit(
                    "next",
                    Object.assign({}, this.formData, {
                        task_start_time: new Date(this.formData.task_start_time).getTime() / 1000,
                        task_end_time: new Date(this.formData.task_end_time).getTime() / 1000,
                    })
                );
            }
        },

        handleCancel() {
            this.$emit("cancel");
        },

        formatDateTime(val, detail = false) {
            if (!val) return undefined;

            const date = new Date(val);

            const year = String(date.getFullYear());
            const month = String(date.getMonth() + 1).padStart(2, "0");
            const day = String(date.getDate()).padStart(2, "0");
            const hour = String(date.getHours()).padStart(2, "0");
            const minutes = String(date.getMinutes()).padStart(2, "0");

            let formatTime = `${year}-${month}-${day}`;

            if (detail) {
                formatTime += ` ${hour}:${minutes}`;
            } else {
                formatTime += " 23:59:59";
            }

            return formatTime;
        },

        initData(data) {
            Object.assign(this.formData, {
                task_mode: data.task_mode,
                task_budget: data.task_budget,
                task_end_time: this.formatDateTime(data.task_end_time),
                task_start_time: this.formatDateTime(data.task_start_time, true),
            });

            console.log("time: ", this.formData);
        },
    },
};
</script>

<style lang="scss" scoped>
.setting-mode {
    box-sizing: border-box;
    padding-left: 60px;
    height: 100%;

    .mode-title {
        font-family: PingFang SC, PingFang SC;
        font-weight: 500;
        font-size: 36px;
        color: #333333;
        margin-top: 0;
    }

    .form-mode {
        .mode-item {
            display: flex;
            padding: 24px 60px 24px 40px;
            background: linear-gradient(90deg, #f4f8fc 0%, #e9f1fb 100%);
            border-radius: 8px 8px 8px 8px;
            opacity: 0.5;
            cursor: pointer;
            border: 2px solid transparent;

            & + .mode-item {
                margin-top: 20px;
            }

            .mode-info {
                flex: 1;

                .mode-label {
                    font-family: PingFang SC, PingFang SC;
                    font-weight: 500;
                    font-size: 24px;
                    color: #333333;
                }

                .mode-desc {
                    margin-block: 32px 24px;
                    font-family: PingFang SC, PingFang SC;
                    font-weight: 400;
                    font-size: 16px;
                    color: #666666;
                }

                .mode-process {
                    font-family: PingFang SC, PingFang SC;
                    font-weight: 400;
                    font-size: 16px;
                    color: #333333;
                }
            }

            img {
                width: 180px;
                height: 180px;
                object-fit: cover;
            }

            &.active {
                border: 2px solid #594fed;
                opacity: 1;
            }
        }
    }

    .form-list {
        margin-top: 40px;

        .form-item {
            display: flex;
            align-items: center;
            gap: 8px;

            & + .form-item {
                margin-top: 24px;
            }

            .form-item_label {
                width: 120px;
                text-align: right;
            }

            .money-input {
                ::v-deep(.el-input__suffix) {
                    color: #333333;
                    display: flex;
                    align-items: center;
                }
            }

            .top-input {
                ::v-deep(.el-input-group__append) {
                    border: none;
                    background: transparent;
                    color: #333333;
                }

                ::v-deep(.el-input__inner) {
                    border-radius: 4px;
                }
            }

            .budget-input {
                position: relative;

                .budget-number {
                    ::v-deep(.el-input__inner) {
                        text-align: left;
                        padding-right: 40px;
                    }
                }

                span {
                    position: absolute;
                    right: 10px;
                    top: 50%;
                    transform: translateY(-50%);
                    font-size: 13px;
                }
            }
        }
    }

    .form-submit {
        margin-top: 80px;
        display: flex;
        gap: 8px;

        .submit-btn {
            padding: 1px 20px;
            border-radius: 16px;
            border: none;
            font-family: PingFang SC, PingFang SC;
            font-weight: 400;
            font-size: 14px;
            line-height: 30px;
            cursor: pointer;

            &.cancel {
                color: #333333;
                background: #f5f7fa;
                border: 1px solid #dcdfe6;
            }

            &.next {
                background: #594fed;
                color: #ffffff;

                &.disabled {
                    cursor: not-allowed;
                    opacity: 0.4;
                }
            }
        }
    }
}
</style>
